import { OSKIconDefinition } from '../osk-icon.types';

export const oskIconCheck: OSKIconDefinition = {
  name: 'check',
  content: '<polyline points="20 6 9 17 4 12" />'
};
